import { InjectionToken } from '@angular/core';

export const GOOGLE_MAPS_API_KEY = new InjectionToken<string>('GOOGLE_MAPS_API_KEY');

export const GOOGLE_MAPS_MAP_ID = new InjectionToken<string>('GOOGLE_MAPS_MAP_ID');
